export default "import React from 'react';\nimport Ellipse from '@splunk/dashboard-visualizations/Ellipse';\n\nexport default () => <Ellipse />;\n";